!function () {
  "use strict";
  const CAPTION_SEL = "[data-zoom-caption]",
    IMAGE_SEL = "[data-zoom-image]",
    THUMBS_TEMPLATE_SEL = "[data-pswp-thumbs-template]",
    SECTION_SEL = "[data-section-type]",
    THUMBS_CONTAINER_SEL = ".pswp__thumbs",
    PRODUCT_IMAGES_TAG = "product-images",
    PRODUCT_COMPONENT_TAG = "product-component",
    DRAGGING_CLASS = "is-dragging",
    SOLDOUT_CLASS = "variant--soldout",
    UNAVAILABLE_CLASS = "variant--unavailable",
    GALLERY_CLASS = "pswp-zoom-gallery",
    SINGLE_CLASS = "pswp-zoom-gallery--single",
    ATTR_SRC = "data-image-src",
    ATTR_WIDTH = "data-image-width",
    ATTR_HEIGHT = "data-image-height";

  class ZoomImages extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest(SECTION_SEL);
      this.images = this.querySelectorAll(IMAGE_SEL);
      this.zoomCaptions = this.container.querySelector(CAPTION_SEL);
      this.thumbsContainer = document.querySelector(THUMBS_CONTAINER_SEL);
    }

    connectedCallback() {
      this.images.forEach((image) => {
        image.addEventListener("click", (event) => {
          event.preventDefault();
          if (image.closest(PRODUCT_IMAGES_TAG).classList.contains(DRAGGING_CLASS)) return;

          /* jostart */
          const visibleImages = this.getVisibleImages();
          const index = visibleImages.indexOf(image);
          if (index === -1) return;
          this.createZoom(index, visibleImages);
          /* joend */

          window.a11y.lastElement = image;
        });

        image.addEventListener("keyup", (event) => {
          if (event.code !== "Enter") return;
          event.preventDefault();

          /* jostart */
          const visibleImages = this.getVisibleImages();
          const index = visibleImages.indexOf(image);
          if (index === -1) return;
          this.createZoom(index, visibleImages);
          /* joend */

          window.a11y.lastElement = image;
        });
      });
    }

    /* jostart */
    // Returns only the zoom images that are currently visible for the selected variant.
    // A slide is excluded only if it's tagged is__variant-img but not the currently selected one.
    getVisibleImages() {
      return Array.from(this.images).filter((image) => {
        const slide = image.closest(".product__slide");
        if (!slide) return true;
        if (slide.classList.contains("is__variant-img") && !slide.classList.contains("selected")) {
          return false;
        }
        return true;
      });
    }
    /* joend */

    createZoom(t, imagesList) {
      /* jostart */
      const sourceImages = imagesList || this.getVisibleImages();
      /* joend */

      const thumbsTemplateHtml = this.container.querySelector(THUMBS_TEMPLATE_SEL)?.innerHTML;
      let items = [];
      let count = 0;

      sourceImages.forEach((image) => {
        const src = image.getAttribute(ATTR_SRC);
        count += 1;
        items.push({
          src: src,
          w: parseInt(image.getAttribute(ATTR_WIDTH)),
          h: parseInt(image.getAttribute(ATTR_HEIGHT)),
          msrc: src,
        });

        if (sourceImages.length === count) {
            /* jostart */
            if (this.thumbsContainer) {
              this.thumbsContainer.innerHTML = sourceImages
                .map((img) => `<img src="${img.getAttribute(ATTR_SRC)}" width="80" height="80" loading="lazy" alt="">`)
                .join('');
            }
            /* joend */

            const colorScheme = this.getColorScheme();
            const options = {
            history: false,
            focus: false,
            index: t,
            mainClass: `${GALLERY_CLASS}${count === 1 ? ` ${SINGLE_CLASS}` : ""}${colorScheme ? ` ${colorScheme}` : ""}`,
            showHideOpacity: true,
            howAnimationDuration: 150,
            hideAnimationDuration: 250,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            captionEl: true,
            closeEl: true,
            closeElClasses: ["caption-close", "title"],
            tapToClose: false,
            clickToCloseNonZoomable: false,
            maxSpreadZoom: 2,
            loop: true,
            spacing: 0,
            allowPanToNext: true,
            pinchToClose: false,
            addCaptionHTMLFn: (item, el, isFake) => {
              this.zoomCaption(item, el, isFake);
            },
            getThumbBoundsFn: () => {
              const activeImage = sourceImages[t];
              const scrollTop = window.scrollY || document.documentElement.scrollTop;
              const rect = activeImage.getBoundingClientRect();
              return { x: rect.left, y: rect.top + scrollTop, w: rect.width };
            },
          };

          new window.theme.LoadPhotoswipe(items, options);
        }
      });
    }

    zoomCaption(item, el) {
      let caption = "";
      const target = el.children[0];

      if (this.zoomCaptions) {
        caption = this.zoomCaptions.innerHTML;

        if (this.zoomCaptions.closest(`.${SOLDOUT_CLASS}`)) {
          target.classList.add(SOLDOUT_CLASS);
        } else {
          target.classList.remove(SOLDOUT_CLASS);
        }

        if (this.zoomCaptions.closest(`.${UNAVAILABLE_CLASS}`)) {
          target.classList.add(UNAVAILABLE_CLASS);
        } else {
          target.classList.remove(UNAVAILABLE_CLASS);
        }
      }

      target.innerHTML = caption;
      return false;
    }

    getColorScheme() {
      const productComponent = this.closest(PRODUCT_COMPONENT_TAG);
      return Array.from(productComponent.classList).find((className) => className.startsWith("color-scheme"));
    }
  }

  if (!customElements.get("zoom-images")) {
    customElements.define("zoom-images", ZoomImages);
  }
}();